export default __webpack_public_path__ + "static/hiv-landscape_section-hero-mobile-471d8c1fc234f4ec495e0195cb45f482.jpg";